import { temAcesso } from '@/shared/auth/temAcesso'
const Etapa = () => import('./Etapa.vue')

export default {
    path: 'etapas/:etapaId',
    name: 'Sgtec_Gerentes_Etapa_Detalhar',
    component: Etapa,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-GER-ETP-01')) {
            next()
        }
    }
}

